import { initEasasJs } from "core/DynamicComponentLoader";
import 'react-tooltip/dist/react-tooltip.css';
import "utils/legacy";
import "utils/translate-mode";
import { getBuildId, isProd } from "utils/utils";
import UserService from "./services/UserService";
import "./style/style";

const init = async () => {
  if (module.hot) {
    console.log("Accepting hot reload...");
    module.hot.accept();
  }

  console.log("EASAS-JS main bundle entry point...");
  console.log(`EASAS-JS is running in ${isProd() ? "production" : "development"} mode`);
  console.log(`Auto CD Build ID: ${getBuildId()}`);

  await UserService.initUser();
  initEasasJs();
}

init();

